import { useGlobalContext } from "../../../../../../Context/Context";
import Button from "../../../../../Custom/Button/Button";

const styles = {
  button: {
    padding: "5px 30px",
    fontWeight: "bold",
    width: "15vw",
    height: "40px",
  },
};

function ButtonsPocetna({ cancelPreview, setCurrentState, onPrint }) {
  const { dictionary } = useGlobalContext();

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        marginTop: "15px",
      }}
    >
      <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
        <div onClick={onPrint}>
          <Button activation={true} style={styles.button}>
            {dictionary["stampaj"]}
          </Button>
        </div>
        <div>
          <Button activation={true} style={styles.button}>
            {dictionary["posalji"]}
          </Button>
        </div>
      </div>
      <div style={{ display: "flex", gap: "10px" }}>
        <div onClick={cancelPreview}>
          <Button activation={true} style={styles.button}>
            {dictionary["nazad"]}
          </Button>
        </div>
        <div onClick={() => setCurrentState("EDIT")}>
          <Button activation={true} style={styles.button}>
            {dictionary["azuriraj"]}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ButtonsPocetna;
